import React from "react";
import {useTranslation} from "react-i18next";
import styled from "styled-components";
import { colors } from "../../common/ui/globalColors";
import {constants} from "../../common/constants/constants";
import {isMobile} from "react-device-detect";

const TenantSearchOptionCardStyled = styled.div`
  .tenant-search-option {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: baseline;
    gap: 8px;
    color: ${props => props.theme.text};
    

    .link {
      color: ${props => props.theme.text};
      opacity: 0.4;
          
          .value-type{
            // catching this property bu not really showing black.. 
            color: ${colors.textColors.black};
          }
    }
    
    .type{
      // joined the value and link under the same so adding this to split
      padding-inline-end: 10px;
    }

    
  }
`

/**
 * @param tenant
 * @returns {JSX.Element}
 * @constructor
 */
export const TenantSearchOptionCard = ({tenant}) => {
    const {t} = useTranslation();
    const tenantDetails = tenant.tenantDetails && tenant.tenantDetails;
    const methodIdRecord = tenantDetails?.find(detail => detail.type === 'methodId');
    const methodName = methodIdRecord?.value ? t(`common.paymentMethods.${methodIdRecord.value}`) : '';
    const firstTenantDetail = tenantDetails && tenantDetails[0];
    // adding trim to avoid names with before or after extra spaces
    let valueToDisplay = firstTenantDetail?.value?.trim();
    if (methodName) {
        valueToDisplay = `(${methodName}) ${valueToDisplay}`;
    }
    const detailsType = firstTenantDetail ? firstTenantDetail.type : '';
    const building = tenant.apartment?.Building;
    const buildingId = building?.externalID;
    const buildingTitle = building?.Title;
    const apartmentNum = tenant.apartment?.ApartmentNum;
    const url = isMobile ? `/${constants.pages.tenantListUrl}/${buildingId}/${apartmentNum}`: `/${constants.pages.newApartmentReport}/${buildingId}/${apartmentNum}`;

    if (!detailsType || !buildingId || !apartmentNum) return null;

    return <TenantSearchOptionCardStyled>
        <div className='tenant-search-option bllink-text-tiny'>
            <a className='link'
               href={`${url}`}>
                <span className='type value-type'>{valueToDisplay}</span>
                <span className='type'>
                    {t('globalSearch.tenant.aptReportLink', {buildingTitle, apartmentNum})}
                </span>
            </a>
        </div>
    </TenantSearchOptionCardStyled>
}
